import React from "react";
import { Button, Card, Grid, List, ListItem, ListItemButton, ListItemText, Menu, MenuItem, TextField, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { FormattedMessage } from "react-intl";
import { useCommonFunctions } from "../../hooks/useCommonFunctions";

const UsersAndRoles: React.FC = () => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [selectedIndex] = React.useState(1);

    const open = Boolean(anchorEl);
  const handleClickListItem = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

    const {
        userRoles,
        searchedUsers,
        searchCriteria,
        selectedUser,
        selectedRole,
        intl,
        handleRoleUpdate,
        handleUserDelete,
        handleSearch,
        setSearchCriteria,
        setSelectedUser,
        setSelectedRole,
      } = useCommonFunctions();

    return (
        <Grid container padding={2}>
            <Grid item xs={12}>
          <Typography variant="h5">
            <FormattedMessage id="users-and-roles" />
          </Typography>
        </Grid>
        <Grid item xs={12} md={4} mt={2}>
          <TextField
            id="searchUsers"
            type="search"
            value={searchCriteria}
            onChange={(e) => setSearchCriteria(e.target.value)}
            placeholder={intl.formatMessage({
              id: "searchPlaceholder",
              defaultMessage: "Search users...",
            })}
            style={{ width: "95%" }}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Button
            id="executeSearch"
            variant="contained"
            onClick={handleSearch}
            sx={{ p: 2, ml: 2, mt: 2, width: { xs: 100, md: 150 } }}
          >
            <FormattedMessage id="search" />
          </Button>
        </Grid>
        <Grid item md={4} />
        <Grid item xs={12} md={6} lg={4}>
          <List
            sx={{
              m: 2,
              bgcolor: "background.paper",
              position: "relative",
              overflow: "auto",
              "& ul": { padding: 0 },
            }}
            subheader={<li />}
          >
            {searchedUsers &&
              searchedUsers.map((user) => (
                <Grid
                  item
                  xs={12}
                  key={`user-${user.id}`}
                  onClick={() => setSelectedUser(user.id!)}
                  className={selectedUser === user.id ? "selected" : ""}
                >
                  <Card
                    sx={{
                      mb: 1,
                      width: "100%",
                      borderRadius: 2,
                      backgroundColor: selectedUser === user.id ? "#1E90FF" : "#87CEEB",
                    }}
                  >
                    <ListItem>
                      <ListItemText primary={`Username: ${user.username}`} />
                    </ListItem>
                    <ListItem>
                      <ListItemText primary={`Id: ${user.id}`} />
                    </ListItem>
                    <ListItem>
                      <ListItemText primary={`Name: ${user.name} ${user.surname}`} />
                    </ListItem>
                    <ListItem>
                      <ListItemText primary={`Phone: ${user.phonenumber}`} />
                    </ListItem>
                    <ListItem>
                      <ListItemText primary={`Email: ${user.email}`} />
                    </ListItem>
                    {user.roles &&
                      user.roles.map((roleId: string, index: number) => {
                        const role = userRoles.find((p) => p.id === roleId);
                        return (
                          <ListItem key={index}>
                            <ListItemText
                              primary={`Role: ${role ? role.name : roleId}`}
                            />
                          </ListItem>
                        );
                      })}
                  </Card>
                  <Button
                    id="delete-user-button"
                    onClick={() => handleUserDelete(user.id!)}
                    variant="contained"
                  >
                    <FormattedMessage id="delete-user" />
                  </Button>
                </Grid>
              ))}
          </List>
        </Grid>
        {selectedUser && (
          <Grid item xs={12} md={6} mt={1}>
            <List
              component="nav"
              aria-label="Device settings"
              sx={{ bgcolor: "background.paper" }}
            >
              <ListItemButton
                id="privilages-list"
                aria-haspopup="listbox"
                aria-controls="user-privilages"
                aria-label="Update user privilages"
                aria-expanded={open ? "true" : undefined}
                onClick={handleClickListItem}
              >
                <ListItemText
                  primary={
                    <Typography component="span" variant="body1">
                      <FormattedMessage id="rights" /> <ExpandMoreIcon />
                    </Typography>
                  }
                  secondary={selectedRole?.name}
                />
              </ListItemButton>
            </List>
            <Menu
              id="user-privilages"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                "aria-labelledby": "lock-button",
                role: "listbox",
              }}
            >
              {userRoles.map((privilage, index) => (
                <MenuItem
                  key={privilage.id}
                  selected={index === selectedIndex}
                  onClick={() => {
                    setSelectedRole(privilage);
                    handleClose();
                  }}
                >
                  {privilage.name}
                </MenuItem>
              ))}
            </Menu>
            <Button onClick={handleRoleUpdate} variant="contained" sx={{ mb: 5 }} id="update-privilages-button">
              <FormattedMessage id="update-privilages" />
            </Button>
          </Grid>
        )}
      </Grid>
    );
}

export default UsersAndRoles;